import React from 'react'
import PropTypes from 'prop-types'

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

const ClientProjectFinancialSummary = ({total_budget,
                                           total_fees,
                                           total_supplier_invoiced,
                                           total_writeoff,
                                           total_invoiced,
                                           total_credit_notes,
                                           amount_to_invoice}) => {

    return (
        <div className="d-flex flex-row justify-content-around pl-4" style={{flex: 2}}>
            <div className="d-flex flex-column border-left pl-3" style={{flex: 1}}>
                <div className="d-flex flex-row justify-content-between">
                    <small><strong>Budget:</strong></small>
                    <small>{format(total_budget)}</small>
                </div>
                <div className="d-flex flex-row justify-content-between">
                    <small><strong>Used:</strong></small>
                    <small>{format(total_fees + total_supplier_invoiced)}</small>
                </div>
                <div className="d-flex flex-row justify-content-between">
                    <small><strong>Remaining:</strong></small>
                    <small>{format(total_budget - (total_fees + total_supplier_invoiced))}</small>
                </div>

            </div>
            <div className="d-flex flex-column border-left pl-3 ml-3" style={{flex: 1}}>
                <div className="d-flex flex-row justify-content-between">
                    <small><strong>Gravity:</strong></small>
                    <small>{format(total_fees)}</small>
                </div>
                <div className="d-flex flex-row justify-content-between">
                    <small><strong>Suppliers:</strong></small>
                    <small>{format(total_supplier_invoiced)}</small>
                </div>
                <div className="d-flex flex-row justify-content-between">
                    <small><strong>Total:</strong></small>
                    <small>{format(total_fees + total_supplier_invoiced)}</small>
                </div>

            </div>
            <div className="d-flex flex-column border-left pl-3 ml-3" style={{flex: 1}}>
                <small><strong>Total Written Off:</strong></small>
                <div style={{flex: 1}} className="d-flex justify-content-center align-items-center">
                    <small>{format(total_writeoff)}</small>
                </div>

            </div>
            <div className="d-flex flex-column border-left pl-3 ml-3" style={{flex: 1}}>
                <div className="d-flex flex-row justify-content-between">
                    <small><strong>Invoiced:</strong></small>
                    <small>{format(total_invoiced)}</small>
                </div>
                <div className="d-flex flex-row justify-content-between">
                    <small><strong>Credit Notes:</strong></small>
                    <small>{format(total_credit_notes)}</small>
                </div>
                <div className="d-flex flex-row justify-content-between">
                    <small><strong>Total:</strong></small>
                    <small>{format(total_invoiced + total_credit_notes)}</small>
                </div>

            </div>
            <div className="d-flex flex-column border-left pl-2 ml-2" style={{flex: 1}}>
                <small><strong>Amount to Invoice:</strong></small>
                <div style={{flex: 1}} className="d-flex justify-content-center align-items-center">
                    <small>{format(amount_to_invoice)}</small>
                </div>
            </div>
        </div>
    )

}

export default ClientProjectFinancialSummary